module.exports = __webpack_public_path__ + "img/header-logoB.0ed0042f.png";